import { FOOTER_URLS_CONSTANTS } from './constants/stringConstants';

export const isConsumptionPageCheck = (pathUrl: string) => {
  let isConsumptionPage = false;
  const pathArray = pathUrl && pathUrl.split('/');
  const ZEE5ORIGINALS = FOOTER_URLS_CONSTANTS.WEB_SERIES;
  const TVSHOWS = FOOTER_URLS_CONSTANTS.TV_SHOWS;
  const regExp = new RegExp(`${TVSHOWS}|${ZEE5ORIGINALS}`, 'g');
  if (
    pathUrl.match(/(kids)\/+(kids-shows)/g) &&
    pathArray.length === 7 &&
    pathArray[pathArray.length - 1] !== FOOTER_URLS_CONSTANTS.EPISODES
  ) {
    isConsumptionPage = true;
  }
  if (
    pathUrl.match(regExp) &&
    pathArray.length === 7 &&
    pathArray[pathArray.length - 1] !== FOOTER_URLS_CONSTANTS.EPISODES
  ) {
    isConsumptionPage = true;
  } else if (
    pathUrl.match(/(movies|kids|news|videos|live-tv|music-videos)/g) &&
    !pathUrl.match(/(kids)\/+(kids-shows)/g) &&
    !pathUrl.match(/(\/genre\/|\/lang\/|\/collections\/)/g) &&
    pathArray.length >= 4
  ) {
    isConsumptionPage = true;
  }
  if (
    pathUrl.match(/(latest|latest1)$/g) ||
    pathUrl.match(/(b2b-consumption|b2b-live-tv)/g)
  ) {
    isConsumptionPage = true;
  }
  return isConsumptionPage;
};
